// extracted by mini-css-extract-plugin
export default {"btn":"CreateSnapshot_btn__L0sIb"};